export default __webpack_public_path__ + "static/media/flow_container.d68af005.svg";